const microsoftForms = {
  student: {
    title: 'Middle School and High School Registration',
    description: 'Register students in grades 6-12 for STEM Career Day.',
    src: process.env.VUE_APP_MS_FORM_STUDENT_URL || 'https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=Zomek4WSmkqfBAiH7-iq4M7uzuEwrupHoXEvu72CcKtUOERPSDEySFhFV0Y0RU9BMlVSVzdXOFFVWS4u&embed=true'
  },
  group: {
    title: 'Group Registration',
    description: 'Register a school or student group for STEM Career Day.',
    src: process.env.VUE_APP_MS_FORM_GROUP_URL || 'https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=Zomek4WSmkqfBAiH7-iq4CILNj0FvrtIovKhDYcZNIJUQjFPTFNSUDYzVjU0N1k1QTNVOTY1Q1hBMy4u&embed=true'
  },
  scholarship: {
    title: 'Scholarship Application',
    description: 'Submit a scholarship application for STEM Career Day.',
    src: process.env.VUE_APP_MS_FORM_SCHOLARSHIP_URL || 'https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=Zomek4WSmkqfBAiH7-iq4GIZvhkE3qlJmN5boAE1B65UQklON1daN1lKMVdHQlFSWTVDM01MOEVCUC4u&embed=true'
  },
  company: {
    title: 'Company Registration',
    description: 'Register your organization to participate in STEM Career Day.',
    src: process.env.VUE_APP_MS_FORM_COMPANY_URL || 'https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=Zomek4WSmkqfBAiH7-iq4NJmVsHAdlFHmShor_-52qlURDVPME9YV085MUdIVEJYQ0s1MU5aSU5MNyQlQCN0PWcu&embed=true'
  }
}

export default microsoftForms
